import './index.scss';
import './notebooks';
import './notebooks_card';
import './contents';
import './statistics_container';
import AjaxComponentLoader from 'utils/ajax_component_loader';

(function ($) {
  'use strict';

  const container = $('.js-q-resources-box-statistics-container');
  const params = container.data();

  if (params) {
    AjaxComponentLoader.load({
      component: 'timeline/resources_box/statistics_container',
      type: 'page_component',
      data: {
        ...params
      }
    }).then((element) => {
      return container.replaceWith(element);
    });
  }
})(jQuery);
